import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      fill="none"
      viewBox="0 0 48 48"
    >
      <path fill="#F7F7F7" d="M4.5 17.7l5.1 23.5H39l5.6-23.5H4.5z"></path>
      <path
        fill="#B2B2B2"
        d="M38.7 42H9.3c-.3 0-.7-.2-.7-.6L3 17.6c-.1-.2 0-.5.1-.6.1-.2.4-.3.6-.3h40.5c.2 0 .4.1.6.3.1.2.2.4.1.6l-5.6 23.9c0 .3-.3.5-.6.5zM9.9 40.5H38l5.2-22.4H4.7l5.2 22.4z"
      ></path>
      <path
        fill="#B2B2B2"
        d="M15.6 18.1c-.4 0-.8-.3-.8-.8v-4.1c0-2.4.9-4.7 2.6-6.5C19.2 5 21.5 4 23.9 4c2.4 0 4.7.9 6.5 2.6 1.7 1.7 2.7 4 2.7 6.4v4.2c0 .4-.3.8-.8.8s-.8-.3-.8-.8V13c0-2-.8-3.9-2.3-5.4-1.5-1.4-3.4-2.2-5.4-2.2-2 0-3.9.8-5.4 2.3-1.4 1.5-2.2 3.4-2.2 5.4v4.2c.2.5-.2.8-.6.8zM15.8 27c-.4 0-.8-.3-.8-.8v-2.8c0-.4.3-.8.8-.8s.8.3.8.8v2.8c0 .5-.4.8-.8.8zM32.4 27c-.4 0-.8-.3-.8-.8v-2.8c0-.4.3-.8.8-.8s.8.3.8.8v2.8c-.1.5-.4.8-.8.8z"
      ></path>
    </svg>
  );
}

export default Icon;